import * as React from "react";
import { useEffect } from "react";
import { observer } from "mobx-react";
import { mapActive } from "../../../map/utils/map-utils";
import { Box } from "@chakra-ui/react";
import { useStores } from "../../../shared/stores/RootStore";

const MainMapBase: React.FC<{
  isHome?: boolean;
  reducedMapSize?: boolean;
  onMapReady?: (map: mapboxgl.Map) => void;
}> = ({ reducedMapSize = false, isHome = false, onMapReady }) => {
  const { mapStore, osaWayStore, osaNodeStore } = useStores();
  const map = mapStore.map;
  const selectedOsaWay = osaWayStore.getSelected();

  /**
   * Instantiate map and add the common controls
   */
  useEffect(() => {
    mapStore.init();

    return () => {
      mapStore.destroy();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (mapActive(map)) {
      mapStore.onSelectedOsaWayChange(selectedOsaWay);
    }

    // eslint-disable-next-line
  }, [mapStore.map, isHome, selectedOsaWay]);

  useEffect(() => {
    if (mapActive(map)) map!.resize();
    // eslint-disable-next-line
  }, [mapStore.map, mapStore.mapResizeTrigger]);

  /**
   * Stop route matching when it's no longer active
   */
  useEffect(() => {
    if (osaNodeStore.pendingCoordsByNodeId.size) {
      osaNodeStore.clearPendingCoordChanges();
    }
    // eslint-disable-next-line
  }, [selectedOsaWay]);

  /**
   * When the list of ways is updated or way/node selection changes, re-center the map
   */
  useEffect(() => {
    mapStore.centerMap();
    //eslint-disable-next-line
  }, [map, mapStore.mapRecenterTrigger]);

  useEffect(() => {
    if (mapActive(map) && onMapReady) {
      onMapReady(map!);
    }
  }, [map, onMapReady]);

  return <Box id="map" flexGrow={1} height="100%" />;
};

export const MainMap = observer(MainMapBase);
